import API from './api';

// Helper function to extract numeric ID from itemId (removes "INV#" prefix)
const extractItemId = (itemId) => {
  if (!itemId) return '';
  // If it starts with "INV#", return the part after it, otherwise return as-is
  return itemId.startsWith('INV#') ? itemId.substring(4) : itemId;
};

export const getAllInventoryItems = async () => {
  try {
    const response = await API.get('/inventory/items');
    return response.data;
  } catch (error) {
    console.error('Error fetching inventory items:', error);
    throw error;
  }
};

export const createInventoryItem = async (itemData) => {
  try {
    const response = await API.post('/inventory/items', itemData);
    return response.data;
  } catch (error) {
    console.error('Error creating inventory item:', error);
    throw error;
  }
};

export const updateInventoryItem = async (itemId, itemData) => {
  try {
    const numericId = extractItemId(itemId);
    const response = await API.put(`/inventory/items/${numericId}`, itemData);
    return response.data;
  } catch (error) {
    console.error(`Error updating inventory item ${itemId}:`, error);
    throw error;
  }
};

export const deleteInventoryItem = async (itemId) => {
  try {
    const numericId = extractItemId(itemId);
    const response = await API.delete(`/inventory/items/${numericId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting inventory item ${itemId}:`, error);
    throw error;
  }
};

export const assignInventory = async (assignmentData) => {
  try {
    const response = await API.post('/inventory/assign', assignmentData);
    return response.data;
  } catch (error) {
    console.error('Error assigning inventory:', error);
    throw error;
  }
};

export const releaseInventory = async (releaseData) => {
  try {
    const response = await API.post('/inventory/release', releaseData);
    return response.data;
  } catch (error) {
    console.error('Error releasing inventory:', error);
    throw error;
  }
};

export const getWorkerInventory = async (mobileNumber) => {
  try {
    const response = await API.get(`/inventory/worker/${mobileNumber}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching worker inventory for ${mobileNumber}:`, error);
    throw error;
  }
};

export const getInventoryReport = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.itemId) params.append('itemId', filters.itemId);
    if (filters.workerMobileNumber) params.append('workerMobileNumber', filters.workerMobileNumber);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    
    const queryString = params.toString();
    const url = `/inventory/report${queryString ? `?${queryString}` : ''}`;
    const response = await API.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching inventory report:', error);
    throw error;
  }
};

export const getItemAssignments = async (itemId) => {
  try {
    const numericId = extractItemId(itemId);
    const url = `/inventory/items/${numericId}/assignments`;
    const response = await API.get(url);
    return response.data;
  } catch (error) {
    console.error(`Error fetching item assignments for ${itemId}:`, error);
    throw error;
  }
};

export const reassignInventory = async (reassignmentData) => {
  try {
    const response = await API.post('/inventory/reassign', reassignmentData);
    return response.data;
  } catch (error) {
    console.error('Error reassigning inventory:', error);
    throw error;
  }
};

